import {  put, takeEvery } from "redux-saga/effects";
import requestApi from "../../utils/request";
import { GET_CITY, GET_COUNTRY, GET_STATE } from "../SagaAction/actions";
import { CityGetDataFailure, CityGetDataRequest, CityGetDataSuccess, CountryGetDataFailure, CountryGetDataRequest, CountryGetDataSuccess, StateGetDataFailure, StateGetDataRequest, StateGetDataSuccess } from "../Slices/CountrySlice";

function* CountryGetData(params){
 try{
    yield put (CountryGetDataRequest())
    const {data} = yield requestApi.post("/country")
    yield put(CountryGetDataSuccess(data))
 }
 catch(err){
    yield put(CountryGetDataFailure(err))
 }
}

function* StateGetData(params){
    try{
        yield put(StateGetDataRequest())
        const {data} = yield requestApi.post(`/state`,params.payload)
        yield put(StateGetDataSuccess(data))
    }
    catch(err){
        yield put(StateGetDataFailure(err))
    }
}

function* CityGetData(params){
    try{
        yield put(CityGetDataRequest())
        const {data} = yield requestApi.post(`/city`,params.payload)
        yield put(CityGetDataSuccess(data))
    }
    catch(err){
        yield put(CityGetDataFailure(err))
    }
}


function* CountrySaga(){
    yield takeEvery(GET_COUNTRY,CountryGetData)
    yield takeEvery(GET_STATE,StateGetData)
    yield takeEvery(GET_CITY,CityGetData)
}

export default CountrySaga;